import { Storage } from ".";
import { WritableDraft } from "immer/dist/internal";

export const save = (
  state: WritableDraft<Storage>[],
  { payload: label }: { payload: string }
) => {
  localStorage.setItem(label, JSON.stringify(state));

  const labels = JSON.parse(localStorage.getItem("labels") ?? "[]");

  // yeah ... fancy
  localStorage.setItem(
    "labels",

    // no it's really fancy
    JSON.stringify([...(new Set([...labels, label]) as any)])
  );
};
